import { Injector } from "@angular/core";
import { ListView } from "../../Data/ListView";
import { BaseNode } from "../BaseNode";
import { PaginationControl } from "../../PaginationControl";

export class ResultList extends BaseNode {
    constructor(injector: Injector) {
       super(injector,new ListView(),"Results"); 
       this.labelNodeName = "Results";
    }

    addResult(requestedNode: BaseNode, pageToRetrieve: PaginationControl, data: any, parentNode: BaseNode): BaseNode|null{
        return null;
    }

    getHeaders(): string[] {
        return ['Results Found'];
    }
   
}